import { ApiError } from "@/shared/lib/api-call";

/// Friendly toast copy for assist failures (spec decision 7). The form stays
/// usable in every case, so all three messages point back to manual writing.
export function draftErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === "RATE_LIMITED" || err.status === 429) {
      return "You're drafting fast. Wait a minute and try again.";
    }
    if (err.code === "SERVICE_UNAVAILABLE" || err.status === 503) {
      return "The drafting assistant is unavailable right now. You can keep writing manually.";
    }
  }
  return "Couldn't draft that just now. You can keep writing manually.";
}
